import { render } from "./NewGateway.vue?vue&type=template&id=87ad6274"
import script from "./NewGateway.vue?vue&type=script&lang=js"
export * from "./NewGateway.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__